import {
  isTextNode,
  isCommentNode,
  isOneOfTags,
  hasNonEmptyShallowTextNodes,
  isSelfClosingElement,
  isTag,
  isElementNode,
} from 'anodum';
import {
  ALTERNATIVE_BOLD,
  ALTERNATIVE_ITALIC,
  BLOCK_ELEMENTS,
  IMAGE_TAG,
  LIST_ELEMENTS,
  LIST_ITEM,
  SUPPORTED_ELEMENTS,
} from '../constants/editable-elements';
import isAligned from './is-aligned';
import isRolledBackTagByStyle from './is-rolled-back-tag-by-style';
import hasBoldStyle from './has-bold-style';
import hasUnderlineStyle from './has-underline-style';
import hasItalicStyle from './has-italic-style';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import isBlockElement from './is-block-element';
import hasStrikethroughStyles from './has-strikethrough-styles';

const isElementToUnwrap = (element) => {
  if (isTextNode(element) || isCommentNode(element) || isSelfClosingElement(element)) return false;

  const isStyledElement =
    hasBoldStyle(element) ||
    hasItalicStyle(element) ||
    hasUnderlineStyle(element) ||
    hasStrikethroughStyles(element);
  const isAlignedElement = isAligned(element);

  const hasSupportedStyles = isStyledElement || (isBlockElement(element) && isAlignedElement);
  const hasChildren = Boolean(element.children.length || hasNonEmptyShallowTextNodes(element));

  if (!isOneOfTags(element, [...SUPPORTED_ELEMENTS, ...ALTERNATIVE_BOLD, ...ALTERNATIVE_ITALIC])) {
    return !hasSupportedStyles && hasChildren;
  }

  if (
    isTag(element, LIST_ITEM) &&
    element.childNodes.length &&
    element.childNodes.length === element.childElementCount &&
    [...element.childNodes].every((el) => isOneOfTags(el, LIST_ELEMENTS))
  ) {
    return true;
  }

  if (
    (isTag(element, LIST_ITEM) &&
      isElementNode(element.parentNode) &&
      element.parentNode.closest(LIST_ITEM)) ||
    (isOneOfTags(element, LIST_ELEMENTS) &&
      isElementNode(element.parentNode) &&
      element.parentNode.closest(LIST_ELEMENTS))
  ) {
    return hasChildren;
  }

  if (
    isTag(element, IMAGE_SELECTOR) &&
    (element.querySelector(IMAGE_SELECTOR) || !element.querySelector(IMAGE_TAG))
  ) {
    // Fixes case in Safari clipboard
    return true;
  }

  if (isRolledBackTagByStyle(element)) {
    return !hasSupportedStyles;
  }

  if (isOneOfTags(element, BLOCK_ELEMENTS)) {
    return isElementNode(element.parentNode) && Boolean(element.parentNode.closest(BLOCK_ELEMENTS));
  }
  return false;
};

export default isElementToUnwrap;
